export enum StorageKeysEnum {
  Token = 'token',
  Session = 'session',
  Language = 'lang',
  LastRequest = 'lastRequest',
  ExportDataFields = 'exportDataFields'
}
